// based on https://www.electronjs.org/docs/latest/api/menu-item#new-menuitemoptions
export const Normal = 'normal'
export const Separator = 'separator'
export const SubMenu = 'submenu'
export const Checkbox = 'checkbox'
export const Radio = 'radio'
